module.exports = __webpack_public_path__ + "static/img/292_phase_function_Paper_PointsHejduk_Prediction.8ad3996.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/292_phase_function_Paper_PointsHejduk_Prediction.png
// module id = GHoD
// module chunks = 0